import ProductInfoContainer from 'pricing-pages-lib/js/components/ProductInfoContainer.tsx';
import { NavMarker } from 'react-rhumb';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import MobileCurrencyPicker from '../MobileCurrencyPicker';
import MobileDropdownNav from '../MobileDropdownNav';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileWrapper = ({
  navMarkerName,
  navItem,
  children
}) => {
  const isAppReady = useGlobalLoading();
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [isAppReady && /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    }), /*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
      selectedNavItem: navItem
    }), /*#__PURE__*/_jsx(ProductInfoContainer, {
      children: children
    })]
  });
};
export default MobileWrapper;